import { Helmet } from 'react-helmet-async';

const SoftwareAppSchema = () => {
  const software = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "SeniorThrive",
    applicationCategory: "HealthApplication",
    operatingSystem: "Web",
    url: "https://seniorthrive.com",
    description: "All-in-one platform helping older adults live safely and independently at home with proactive safety, wellness, and care coordination.",
    offers: {
      "@type": "Offer",
      category: "FreeTrial",
      price: 0,
      priceCurrency: "USD",
      description: "7-day free trial with full features"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(software)}</script>
    </Helmet>
  );
};

export default SoftwareAppSchema;